import accordion from "../../resources/js/modules/accordion";

window.addEventListener('load', () => {
    const accordions = document.querySelectorAll('.accordion');
    if (!accordions.length > 0) return;
    accordions.forEach(acc => accordion(acc));
});